// MissionVisionDynamicSection.jsx

import React from 'react';
import './mission-vision.css';

const MissionIcon = () => (
  <svg fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" stroke="currentColor" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="8"></circle>
    <circle cx="12" cy="12" r="3"></circle>
    <line x1="12" y1="2" x2="12" y2="5"></line>
    <line x1="12" y1="19" x2="12" y2="22"></line>
  </svg>
);

const VisionIcon = () => (
  <svg fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" stroke="currentColor" viewBox="0 0 24 24">
    <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z"></path>
    <circle cx="12" cy="12" r="3"></circle>
  </svg>
);

const PurposeIcon = () => (
  <svg fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" stroke="currentColor" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="10"></circle>
    <polygon points="16 8 12 14 8 16 10 10 14 8"></polygon>
  </svg>
);

const DynamicTile = ({ title, icon, content, delay }) => (
  <div className="dynamic-tile" data-aos="fade-up" data-aos-delay={delay}>
    <div className="icon-wrap">
      {icon}
    </div>
    <h3 className="tile-title">{title}</h3>
    <p className="tile-content">{content}</p>
  </div>
);

const MissionVisionDynamicSection = () => {
  return (
    <section className="dynamic-mv-container">

      <div className="mv-header-parallax">

  <h2 className="display-4 mission-title mb-2 text-dark">
 <span style={{ color: "white", fontWeight: "700" }}>The Pillars</span>
  <span className="mission-secondary-info"> of Our Strategy</span>
</h2>

      </div>
<div className="tile-band-wrapper">
  <DynamicTile
    title="Our Mission"
    icon={<MissionIcon />}
    content="To accelerate the financial journey of our clients and business segments through tailored technology solutions, delivering market-leading performance and operational transparency."
    delay="100"
  />

  <DynamicTile
    title="Our Vision"
    icon={<VisionIcon />}
    content="To become the leading integrated fintech platform of the next decade, setting the benchmark for trust, innovation, and ethical growth in global finance."
    delay="300"
  />

  <DynamicTile
    title="Core Purpose"
    icon={<PurposeIcon />}
    content="Unlocking opportunity, we exist to simplify complex financial access and empower diverse communities and businesses to realize their highest potential."
    delay="500"
  />
</div>


    </section>
  );
};

export default MissionVisionDynamicSection;
